export default {
  backgroundColor: Styles.color.white,
  textColor: Styles.color.black,
  titleColor: Styles.color.black,
};
